import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useSelector } from 'react-redux'

import { selectedControllerDataSelector } from '../../../../../../../../../modules/selectors/app'

import useStyles from './styles'

const AssetPreviewCell = ({ productData, isInvalid, customText, isEditMode }) => {
  const classes = useStyles()
  const selectedController = useSelector(selectedControllerDataSelector)
  const customProductLabel = selectedController.product_custom_text_label

  return (
    <div
      className={classnames({
        [classes.isInvalid]: isInvalid
      })}
    >
      {productData.internal_id && <div className={classes.assetId}>{productData.internal_id}</div>}
      <div className={classes.name}>{productData.name}</div>
      {!isEditMode && customProductLabel && customText && (
        <div className={classes.customLabel}>
          {customProductLabel}: {customText}
        </div>
      )}
    </div>
  )
}

AssetPreviewCell.propTypes = {
  productData: PropTypes.object,
  isInvalid: PropTypes.bool,
  customText: PropTypes.string,
  isEditMode: PropTypes.bool
}

export default AssetPreviewCell
